import { v4 as uuidV4 } from "uuid";
import * as types from "./types";

export const apiRequest = ({ requestType, message }) => ({
  type: types.API_REQUEST,
  requestType,
  message: message || "",
  id: uuidV4(),
});
